module.exports = __webpack_public_path__ + "img/ignite360.9acf9ff6.png";